const voucherDeliveryCountriesData = [
  { title: 'United Kingdom', value: 'GB', requiresTimezone: false },
  { title: 'Cyprus', value: 'CY', requiresTimezone: false },
  { title: 'Ireland', value: 'IE', requiresTimezone: false },
];

export default voucherDeliveryCountriesData;
